import { Calendar, Lightbulb, ListTodo, Wallet } from 'lucide-react';
import type { Seccion } from '../types';

interface Props {
  seccion: Seccion;
  onCambiar: (seccion: Seccion) => void;
}

const tabs: { id: Seccion; label: string; icono: typeof Calendar; activo: string }[] = [
  { id: 'citas', label: 'Citas', icono: Calendar, activo: 'bg-indigo-600' },
  { id: 'pagos', label: 'Pagos', icono: Wallet, activo: 'bg-emerald-600' },
  { id: 'tareas', label: 'Tareas', icono: ListTodo, activo: 'bg-violet-600' },
  { id: 'ideas', label: 'Ideas', icono: Lightbulb, activo: 'bg-amber-500' },
];

export function Navegacion({ seccion, onCambiar }: Props) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-2 mb-4 flex gap-2">
      {tabs.map(({ id, label, icono: Icono, activo }) => {
        const activa = seccion === id;
        return (
          <button
            key={id}
            onClick={() => onCambiar(id)}
            className={`flex-1 min-w-0 flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 px-1 sm:px-3 py-2 sm:py-3 rounded-lg text-xs sm:text-sm font-medium transition-colors ${
              activa ? `${activo} text-white shadow-md` : 'text-gray-600 hover:bg-gray-100'
            }`}
          >
            <Icono size={18} />
            {label}
          </button>
        );
      })}
    </div>
  );
}
